<template lang="pug">
  component(:is='getCompent')
</template>

<script>
// import themeA from '@/template/a'
import themeB from '@/template/b'
import { getWxShare } from '@/api'
import { mapGetters } from 'vuex'
export default {
  name: 'home',
  data() {
    return {
      compName: themeB,
    }
  },
  computed: {
    ...mapGetters(['getVideoInfo']),
    getCompent() {
      return this.compName
    },
  },
  created() {
    let timer = setInterval(() => {
      if (window.wx && Object.keys(this.getVideoInfo).length) {
        this.getWXShareData()
        clearInterval(timer)
        timer = null
      }
    }, 500)
  },
  methods: {
    getWXShareData() {
      let shareurl = window.location.href
      let wx = window.wx
      getWxShare(shareurl).then(data => {
        if (data) {
          wx.config({
            debug: false,
            appId: data.appid,
            timestamp: data.timestamp,
            nonceStr: data.nonce,
            signature: data.signature,
            jsApiList: [
              'onMenuShareTimeline',
              'openLocation',
              'getLocation',
              'onMenuShareAppMessage',
              'onMenuShareQQ',
              'onMenuShareQZone',
              'onMenuShareWeibo',
              'showOptionMenu',
            ],
          })

          let shareContent = {
            title:
              this.getVideoInfo.sharetitle ||
              this.getVideoInfo.video_name ||
              ' ',
            desc:
              this.getVideoInfo.sharecontent ||
              this.getVideoInfo.video_dec ||
              ' ',
            link: shareurl,
            imgUrl:
              this.getVideoInfo.shareico || this.getVideoInfo.icon_src || '',
            success: () => {},
            cancel: () => {},
          }

          window.wx.ready(function() {
            wx.showOptionMenu()
            wx.onMenuShareTimeline(shareContent)
            // 分享给朋友
            wx.onMenuShareAppMessage(shareContent)
            // QQ
            wx.onMenuShareQQ(shareContent)
            // QQ微博
            wx.onMenuShareWeibo(shareContent)
            // QQ空间
            wx.onMenuShareQZone(shareContent)
          })
          wx.error(res => {
            console.log(res)
          })
        }
      })
    },
  },
}
</script>
<style lang="stylus">
@import '~assets/styles/variables.styl'
.home
  height: 100%
  box-sizing: border-box

.pendant
  position: fixed
  left: 10px
  // padding: 10px
  overflow: hidden
  z-index: $--zindex-low
</style>
